// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"6f11b7de","952":"8795317f"}[chunkId] + ".chunk.js";
};